<script>
	import { onMount, onDestroy } from 'svelte';
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
		Progress
	} from '@sveltestrap/sveltestrap';
	import { wsEndpoint } from '../services/api.js';
	import { showToast } from '../services/dcToasts.js';
	import { rtMessages, svrMessages, svrEvents } from '../stores/rtDataStore.js';
	import { get } from 'svelte/store';
	import BackendProcessesDetail from './BackendProcessesDetail.svelte';
	import { userObj } from '../stores/authUserStore.js';

	let ws;
	let rtIconColour = $state('black');
	let modal_processes_dialog = $state(false);
	let showBottomProcessBoxes = $state(false);
	let agedOut_rtMsg = 1000 * 60 * 60; // 1 hour
	const cleanupFrequency = 1000 * 60; // 1 minute
	const maxActiveProcessRows = 150;
	const bottomBoxesStorageKey = 'dcnServices.showBottomProcessBoxes';

	let reconnectTimeoutShort = false;
	let reconnectTimeout;
	let reconnectTimeoutShortId;
	let destroyed = false;

	// Store cleanup references
	let cleanupInterval;
	let activityHeartbeatInterval;
	let userObjUnsubscribe;
	let rtMessagesUnsubscribe;

	let timeoutMap = new Map();

	// const _userObj = get(userObj);

	function updateRtIcon(mtype) {
		let lightgreen = '#00ea00';
		let darkgreen = '#00bd00';
		if (mtype.toLowerCase() === 'error') {
			rtIconColour = 'red';
		} else if (mtype.toLowerCase() === 'message') {
			if (rtIconColour === darkgreen) {
				rtIconColour = lightgreen;
			} else {
				rtIconColour = darkgreen;
			}
		} else if (mtype.toLowerCase() === 'socket_offline') {
			rtIconColour = 'gray';
		} else if (mtype.toLowerCase() === 'socket_online') {
			rtIconColour = lightgreen;
		} else if (mtype.toLowerCase() === 'socket_error') {
			rtIconColour = 'red';
		} else if (mtype.toLowerCase() === 'socket_disconnect') {
			rtIconColour = 'gray';
		} else {
			rtIconColour = 'black';
		}
	}

	let current_user = '';
	let current_AccessGroup = [];

	function arraysEqual(arr1, arr2) {
		if (arr1.length !== arr2.length) return false;
		return arr1.every((value, index) => value === arr2[index]);
	}

	onMount(() => {
		destroyed = false;
		showBottomProcessBoxes = window.localStorage.getItem(bottomBoxesStorageKey) === 'true';
		//
		userObjUnsubscribe = userObj.subscribe((value) => {
			// console.log('UserObj changed: ', value);
			// test is ws is connected
			if (ws !== undefined && ws.readyState === WebSocket.OPEN) {
				console.debug('WebSocket is connected');
				if (
					current_user !== value.Username ||
					!arraysEqual(current_AccessGroup, value.AccessGroup)
				) {
					// close the ws connection
					current_user = value.Username;
					current_AccessGroup = value.AccessGroup;
					console.warn('User detail change so reconnect web socket.');
					ws.close();
					reconnectTimeoutShort = true;
				}
			} else {
				console.debug('WebSocket is not connected');
			}
		});

		cleanupInterval = setInterval(() => {
			let now = new Date();
			let now_ageOut = new Date(now - agedOut_rtMsg);
			let targetArray = get(rtMessages);
			targetArray.forEach((value) => {
				if (
					value.complete === true ||
					String(value.complete).toLowerCase() === 'true' ||
					value.date_recieved < now_ageOut
				) {
					RtComponentArray_Remove(value);
				}
			});
		}, cleanupFrequency);

		//
		///////////////////////
		//
		rtMessagesUnsubscribe = rtMessages.subscribe((theArray) => {
			UpdateRtArray(theArray);
		});
		activityHeartbeatInterval = setInterval(sendActivityHeartbeat, 60 * 1000);
		// connect to socket.
		setTimeout(() => {
			// console.log('Connecting to WebSocket');
			connectToWebSocket();
		}, 1000);
	});

	function UpdateRtArray(theArray) {
		const max_mon_lines = 5; //
		let max_mon_ptr = 0;

		for (let i = 0; i < theArray.length; i++) {
			if (theArray[i].mtype === 'task_message') {
				progressItems[max_mon_ptr].percent_done = theArray[i].percent_done;
				progressItems[max_mon_ptr].udate = new Date();
				progressItems[max_mon_ptr].uuid = theArray[i].uuid;
				max_mon_ptr++;
			}
			if (max_mon_ptr >= max_mon_lines) {
				break;
			}
		}
		//
		if (max_mon_ptr < max_mon_lines) {
			for (let tt = max_mon_ptr; tt <= max_mon_lines - 1; tt++) {
				progressItems[tt].percent_done = 0;
				progressItems[tt].udate = new Date();
				progressItems[tt].uuid = tt;
			}
		}
	}

	onDestroy(() => {
		destroyed = true;
		// Clean up interval
		if (cleanupInterval) {
			clearInterval(cleanupInterval);
		}
		if (activityHeartbeatInterval) {
			clearInterval(activityHeartbeatInterval);
		}

		// Unsubscribe from stores
		if (userObjUnsubscribe) {
			userObjUnsubscribe();
		}
		if (rtMessagesUnsubscribe) {
			rtMessagesUnsubscribe();
		}
		//
		if (ws) {
			ws.onopen = null;
			ws.onmessage = null;
			ws.onclose = null;
			ws.onerror = null;
			ws.close();
			console.debug('WebSocket connection closed');
		}

		timeoutMap.forEach((timeoutId) => {
			clearTimeout(timeoutId);
		});
		timeoutMap.clear();

		if (reconnectTimeout) {
			clearTimeout(reconnectTimeout);
		}
		if (reconnectTimeoutShortId) {
			clearTimeout(reconnectTimeoutShortId);
		}
	});

	function connectToWebSocket() {
		if (destroyed) return;
		if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) return;
		ws = new WebSocket(wsEndpoint);
		ws.onopen = function () {
			console.debug('WebSocket connected');
			if (current_user === '') {
				current_user = $userObj.Username;
			}
			if (current_AccessGroup.length === 0) {
				current_AccessGroup = $userObj.AccessGroup;
			}
			updateRtIcon('message');
			sendActivityHeartbeat();
		};
		ws.onmessage = function (event) {
			updateRtIcon('message');

			let message_json = null;
			try {
				message_json = JSON.parse(event.data);
			} catch (err) {
				console.debug('Error parsing JSON: ' + err);
				return;
			}
			if (message_json.hasOwnProperty('itemtype')) {
				if (message_json['itemtype'] === 'event') {
					// broadcast the event.
					svrEvents.add({
						eventName: message_json['message'],
						data: message_json['data']
					});

					let event = new CustomEvent(message_json['message'], {});
					window.dispatchEvent(event);
					return;
				}
			}
			if (!message_json.hasOwnProperty('itemtype')) {
				AddNewMessage(message_json);
			}
			//
			// Old stuff we did..
			//
			let r = message_json;
			if (r.hasOwnProperty('itemtype')) {
				svrMessages.add(r);
				//
				const severity = String(r.severity || 'info').toLowerCase();
				if (severity === 'error' || severity === 'danger') {
					showToast(r.severity, r.message, 'error');
				} else if (severity === 'warning' || severity === 'warn') {
					showToast(r.severity, r.message, 'warning');
				} else if (severity === 'success') {
					showToast(r.severity, r.message, 'success');
				} else {
					showToast(r.severity || 'INFO', r.message, 'info');
				}
			} else if (r.hasOwnProperty('username')) {
				if (r.is_logged_in) {
					showToast('INFO', r.username + ' has login', 'info');
				} else {
					showToast('INFO', r.username + ' has logged out', 'info');
				}
			}
		};

		ws.onclose = function () {
			console.debug('WebSocket closed');
			ws = undefined;
			if (destroyed) return;
			updateRtIcon('socket_offline');
			if (reconnectTimeoutShort) {
				reconnectTimeoutShort = false;
				if (reconnectTimeoutShortId) clearTimeout(reconnectTimeoutShortId);
				reconnectTimeoutShortId = setTimeout(() => {
					connectToWebSocket();
				}, 500);
			} else {
				if (reconnectTimeout) clearTimeout(reconnectTimeout);
				reconnectTimeout = setTimeout(() => {
					connectToWebSocket();
				}, 5000);
			}
		};

		ws.onerror = function (event) {
			console.debug('WebSocket error: ' + event);
			updateRtIcon('socket_error');
		};
	}

	function sendActivityHeartbeat() {
		if (!current_user || !ws || ws.readyState !== WebSocket.OPEN) return;
		ws.send(JSON.stringify({ itemtype: 'user_activity' }));
	}

	function AddNewMessage(JSONmsg) {
		// place into RtComponentArray
		RtComponentArray_Add_Replace(JSONmsg);
		// $scope.RtComponentArray[JSONmsg.uuid] = JSONmsg;
		if (JSONmsg.complete === true || JSONmsg.complete === 'True') {
			if (String(JSONmsg.title || '').startsWith('CPL Crawler:')) {
				// remove stright away
				RtComponentArray_Remove(JSONmsg);
			} else {
				// timer that will remove item after 2 seconds..
				if (timeoutMap.has(JSONmsg.uuid)) {
					clearTimeout(timeoutMap.get(JSONmsg.uuid));
				}
				const timeoutId = setTimeout(function () {
					RtComponentArray_Remove(JSONmsg);
					timeoutMap.delete(JSONmsg.uuid);
				}, 2000);
				timeoutMap.set(JSONmsg.uuid, timeoutId);
			}
		}
		if (JSONmsg.severity === 'WARN' || JSONmsg.is_error === true) {
			if (String(JSONmsg.title || '').indexOf('Test Cinema') !== -1) {
				if (timeoutMap.has(JSONmsg.uuid)) {
					clearTimeout(timeoutMap.get(JSONmsg.uuid));
				}
				const timeoutId = setTimeout(() => {
					RtComponentArray_Remove(JSONmsg);
					timeoutMap.delete(JSONmsg.uuid); // Cleanup timeout reference
				}, 1000);
				timeoutMap.set(JSONmsg.uuid, timeoutId);
			}
		}
	}

	//
	///////////////////////////////////////
	// In fo box stuff

	function RtComponentArray_Add_Replace(JSONmsg) {
		JSONmsg.date_recieved = new Date();
		rtMessages.update((messages) => {
			// Find the index of the message with the same uuid
			const index = messages.findIndex((message) => message.uuid === JSONmsg.uuid);
			let nextMessages;

			if (index !== -1) {
				// If found, replace the message at the found index
				nextMessages = messages.map((message, messageIndex) =>
					messageIndex === index ? JSONmsg : message
				);
			} else {
				// If not found, add the new message
				nextMessages = [JSONmsg, ...messages];
			}

			return nextMessages
				.filter((message) => message && message.uuid)
				.slice(0, maxActiveProcessRows);
		});
	}

	function RtComponentArray_Remove(JSONmsg) {
		if (JSONmsg === null) {
			return;
		} else if (JSONmsg.uuid === null) {
			return;
		}
		// Clear timeout if it exists
		if (timeoutMap.has(JSONmsg.uuid)) {
			clearTimeout(timeoutMap.get(JSONmsg.uuid));
			timeoutMap.delete(JSONmsg.uuid);
		}

		if (!JSONmsg.hasOwnProperty('severity')) {
			// add severity property if it does not exist.
			JSONmsg.severity = 'INFO';
		}

		svrMessages.add(JSONmsg);
		rtMessages.update((messages) => {
			// Find the index of the message with the same uuid
			const index = messages.findIndex((message) => message.uuid === JSONmsg.uuid);

			if (index !== -1) {
				return messages.filter((message, messageIndex) => messageIndex !== index);
			}

			return messages;
		});
	}

	function dismissBottomProcess(uuid) {
		if (!uuid) return;
		if (timeoutMap.has(uuid)) {
			clearTimeout(timeoutMap.get(uuid));
			timeoutMap.delete(uuid);
		}
		rtMessages.update((messages) => messages.filter((message) => message?.uuid !== uuid));
	}

	function uniqueBottomProcessMessages(messages) {
		const seen = new Set();
		return (messages || [])
			.filter((message) => {
				if (!message?.uuid || seen.has(message.uuid)) return false;
				seen.add(message.uuid);
				return true;
			})
			.reverse();
	}

	let bottomProcessItems = $derived(uniqueBottomProcessMessages($rtMessages));

	function boolish(value) {
		return value === true || String(value ?? '').toLowerCase() === 'true';
	}

	function bottomBoxTone(message) {
		const severity = String(message?.severity ?? '').toUpperCase();
		if (message?.is_error || severity === 'ERROR' || severity === 'DANGER') return 'process-error';
		if (severity === 'WARN' || severity === 'WARNING') return 'process-warning';
		if (boolish(message?.complete)) return 'process-complete';
		return 'process-active';
	}

	function percentDone(value) {
		const numericValue = Number(value ?? 0);
		return Number.isFinite(numericValue) ? Math.max(0, Math.min(100, numericValue)) : 0;
	}

	function toggleBottomProcessBoxes() {
		showBottomProcessBoxes = !showBottomProcessBoxes;
		window.localStorage.setItem(bottomBoxesStorageKey, String(showBottomProcessBoxes));
	}

	function portal(node) {
		if (typeof document === 'undefined') return {};
		document.body.appendChild(node);
		return {
			destroy() {
				node.remove();
			}
		};
	}

	//
	///////////////////////////////////////
	// Progress bar stuff

	let progressItems = $state([
		{ uuid: 1, percent_done: 0, udate: new Date() },
		{ uuid: 2, percent_done: 0, udate: new Date() },
		{ uuid: 3, percent_done: 0, udate: new Date() },
		{ uuid: 4, percent_done: 0, udate: new Date() },
		{ uuid: 5, percent_done: 0, udate: new Date() }
		// { uuid: 6, percent_done: 0, free: true, udate: new Date() }
		// { id:7, value: 70 }
	]);

	function toggleProcessesModal() {
		modal_processes_dialog = !modal_processes_dialog;
	}

	function openProcessesModal() {
		modal_processes_dialog = true;
	}

	function handleProcessesKeydown(event) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			openProcessesModal();
		}
	}
</script>

<div class="BaPrInfo">
	<div
		class="InfoCont1"
		onclick={openProcessesModal}
		role="button"
		tabindex="0"
		onkeydown={handleProcessesKeydown}
	>
		<div style="font-size: 10px">
			<!--			<Icon name="server" size="10px" color={rtIconColour} />-->
			<i class="fas fa-server" size="10px" style="color: {rtIconColour};"></i>
			Backend Processes
		</div>
		<div class="pbarcontainer">
			{#each progressItems as p_item (p_item.uuid)}
				<Progress striped value={p_item.percent_done} class="pBar progress-sm" />
			{/each}
		</div>
	</div>
</div>

<Modal
	size="lg"
	className="modal-lg modal-dialog-scrollable"
	scrollable={true}
	isOpen={modal_processes_dialog}
	toggle={toggleProcessesModal}
>
	<ModalHeader>Backend Processes and Info History</ModalHeader>
	<ModalBody>
		{#if modal_processes_dialog}
			<BackendProcessesDetail />
		{/if}
	</ModalBody>
	<ModalFooter class="backend-processes-modal-footer">
		<button
			type="button"
			role="switch"
			aria-checked={showBottomProcessBoxes}
			class="bottom-process-toggle"
			onclick={toggleBottomProcessBoxes}
		>
			<span class:active={showBottomProcessBoxes} class="switch-track" aria-hidden="true">
				<span class="switch-thumb"></span>
			</span>
			Show active task boxes along the bottom of the screen
		</button>
		<Button color="secondary" onclick={toggleProcessesModal}>Close</Button>
	</ModalFooter>
</Modal>

{#if showBottomProcessBoxes && bottomProcessItems.length > 0}
	<div use:portal class="bottom-process-tray" aria-label="Active background tasks">
		{#each bottomProcessItems as message (message.uuid)}
			<button
				type="button"
				class="bottom-process-box {bottomBoxTone(message)}"
				aria-label={`Dismiss task ${message.title || 'Backend process'}`}
				title="Click to dismiss this task box"
				onclick={() => dismissBottomProcess(message.uuid)}
			>
				<div class="bottom-process-title">{message.title || 'Backend process'}</div>
				<div class="bottom-process-message">{message.message || ''}</div>
				<div class="bottom-process-progress" aria-hidden="true">
					<div
						class:error={message.is_error}
						class:complete={boolish(message.complete)}
						class="bottom-process-progress-value"
						style={`width: ${percentDone(message.percent_done)}%`}
					></div>
				</div>
			</button>
		{/each}
	</div>
{/if}

<style>
	.pbarcontainer {
		width: 100%;
	}

	:global(.pBar) {
		margin: 2px;
	}

	.BaPrInfo {
		/*background-color: #f8f9fa;*/
		padding: 2px;
		/*display: block;*/
		width: 150px;

		display: flex;
		justify-content: center;
		align-items: center;
	}

	.InfoCont1 {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	:global(.backend-processes-modal-footer) {
		justify-content: space-between;
	}

	.bottom-process-toggle {
		display: inline-flex;
		align-items: center;
		gap: 10px;
		padding: 4px 8px;
		border: 0;
		border-radius: 4px;
		background: transparent;
		color: var(--bs-body-color);
		font-size: 13px;
		font-weight: 500;
		text-align: left;
	}

	.bottom-process-toggle:hover {
		background: var(--bs-tertiary-bg);
	}

	.bottom-process-toggle:focus-visible {
		outline: 2px solid var(--bs-primary);
		outline-offset: 2px;
	}

	.switch-track {
		position: relative;
		display: inline-flex;
		width: 40px;
		height: 22px;
		flex: 0 0 40px;
		align-items: center;
		padding: 2px;
		border: 1px solid var(--bs-border-color);
		border-radius: 12px;
		background: var(--bs-secondary-bg);
		transition: background-color 120ms ease;
	}

	.switch-track.active {
		background: var(--bs-primary);
	}

	.switch-thumb {
		display: block;
		width: 16px;
		height: 16px;
		border: 1px solid var(--bs-border-color);
		border-radius: 50%;
		background: #fff;
		box-shadow: 0 1px 2px rgb(0 0 0 / 20%);
		transition: transform 120ms ease;
	}

	.switch-track.active .switch-thumb {
		transform: translateX(18px);
	}

	.bottom-process-tray {
		position: fixed;
		z-index: 1040;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		flex-wrap: wrap;
		align-items: flex-end;
		background: color-mix(in srgb, var(--bs-body-bg) 70%, transparent);
		backdrop-filter: blur(4px);
	}

	.bottom-process-box {
		height: 48px;
		min-width: 0;
		flex: 0 0 25%;
		overflow: hidden;
		padding: 4px 8px;
		border: 1px solid var(--bs-border-color);
		background: color-mix(in srgb, var(--bs-body-bg) 95%, transparent);
		color: var(--bs-body-color);
		text-align: left;
		box-shadow: 0 -2px 5px rgb(0 0 0 / 12%);
	}

	.bottom-process-box:hover {
		filter: brightness(0.97);
	}

	.bottom-process-box:focus-visible {
		position: relative;
		z-index: 1;
		outline: 2px solid var(--bs-primary);
		outline-offset: -2px;
	}

	.bottom-process-box.process-error {
		border-color: rgb(220 53 69 / 60%);
		background: rgb(220 53 69 / 20%);
	}

	.bottom-process-box.process-warning {
		border-color: rgb(255 193 7 / 60%);
		background: rgb(255 193 7 / 20%);
	}

	.bottom-process-box.process-complete {
		border-color: rgb(25 135 84 / 60%);
		background: rgb(25 135 84 / 20%);
	}

	.bottom-process-title,
	.bottom-process-message {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.bottom-process-title {
		font-size: 12px;
		font-weight: 600;
		line-height: 16px;
	}

	.bottom-process-message {
		color: var(--bs-secondary-color);
		font-size: 10px;
		line-height: 12px;
	}

	.bottom-process-progress {
		height: 4px;
		margin-top: 4px;
		overflow: hidden;
		border-radius: 2px;
		background: var(--bs-secondary-bg);
	}

	.bottom-process-progress-value {
		height: 100%;
		border-radius: 2px;
		background: var(--bs-info);
		transition: width 120ms ease;
	}

	.bottom-process-progress-value.error {
		background: var(--bs-danger);
	}

	.bottom-process-progress-value.complete {
		background: var(--bs-success);
	}

	@media (max-width: 991.98px) {
		.bottom-process-box {
			flex-basis: 50%;
		}
	}

	@media (max-width: 575.98px) {
		.bottom-process-box {
			flex-basis: 100%;
		}
	}
</style>
